import {
  type GetWorkerStageResponse,
  getWorkerStageResponse,
} from "@clipboard-health/contract-worker-app-bff";
import { get } from "@src/appV2/api/api";
import { environmentConfig } from "@src/appV2/environment";
import { APP_V2_APP_EVENTS } from "@src/appV2/lib/analytics";
import {
  useQuery,
  useQueryClient,
  type UseQueryOptions,
  type UseQueryResult,
} from "@tanstack/react-query";

import { WORKER_STAGE_QUERY_KEY } from "./constants";

export const GET_WORKER_STAGE_PATH = "/worker-stage";

export interface WorkerStageResponse {
  stage: string;
  substage?: {
    name: string;
  };
}

export interface WorkerStageChangedResult extends WorkerStageResponse {
  changed: boolean;
}

export function useGetWorkerStage(
  options: UseQueryOptions<WorkerStageChangedResult> = {}
): UseQueryResult<WorkerStageChangedResult> {
  const queryClient = useQueryClient();
  const previousValue = queryClient.getQueryData<WorkerStageChangedResult>([
    WORKER_STAGE_QUERY_KEY,
  ]);

  return useQuery({
    queryKey: [WORKER_STAGE_QUERY_KEY],
    queryFn: async () => {
      const response = await get<undefined, GetWorkerStageResponse>({
        url: `${environmentConfig.REACT_APP_WORKER_APP_BFF_URL}${GET_WORKER_STAGE_PATH}`,
        responseSchema: getWorkerStageResponse,
      });

      const { data: responseBody } = response;

      const { stage, substage } = responseBody.data.attributes;

      return {
        stage,
        substage,
        changed: previousValue?.stage !== stage || previousValue?.substage?.name !== substage?.name,
      };
    },
    meta: {
      logErrorMessage: APP_V2_APP_EVENTS.GET_WORKER_STAGE_FAILURE,
    },
    ...options,
  });
}
